var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('Career',{attrs:{"id":"/"}}),_c('Awards',{attrs:{"id":"premios"}}),_c('Courses',{attrs:{"id":"servicios"}}),_c('Nominations',{attrs:{"id":"nominaciones"}}),_c('Contact',{attrs:{"id":"contacto"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }